export const Empty = ({ when, children }) => {
  if (when) return null;

  return children;
};
